import { gql } from '@apollo/client';

export const ASSIGN_CABLES_TO_REEL = gql`
  mutation AssignCablesToReel($assignCablesToReelInput: AssignCablesToReelInput!) {
    assignCablesToReel(assignCablesToReelInput: $assignCablesToReelInput) {
      errors
      reelId
      cableReels {
        assignedLength
        cutLength
        cableId
        reelId
        cable {
          id
          tag
          unit
          facility
          engrLength
          numberOfCables
        }
        id
        sequenceNumber
      }
    }
  }
`;
